import { lazy, Suspense } from "react";
import { Outlet, type RouteObject } from "react-router";
import { LineLoading } from "@/components/loading";
import SimpleLayout from "@/layouts/simple";
import { lazyRoute } from "./dashboard/utils";

const Page403 = lazy(() => import("@/pages/sys/error/Page403"));
const Page404 = lazy(() => import("@/pages/sys/error/Page404"));
const Page500 = lazy(() => import("@/pages/sys/error/Page500"));

export const mainRoutes: RouteObject[] = [
	{
		path: "/",
		element: (
			<SimpleLayout>
				<Suspense fallback={<LineLoading />}>
					<Outlet />
				</Suspense>
			</SimpleLayout>
		),
		children: [
			{ path: "500", element: <Page500 /> },
			{ path: "404", element: <Page404 /> },
			{ path: "403", element: <Page403 /> },
		],
	},
	{
		path: "/zyusetu/create",
		element: (
			<SimpleLayout showHeader={false}>
				<Suspense fallback={<LineLoading />}>
					<Outlet />
				</Suspense>
			</SimpleLayout>
		),
		children: [
			{ index: true, ...lazyRoute("/pages/zyusetu/create") },
			{ path: ":id", ...lazyRoute("/pages/zyusetu/create") },
		],
	},
];
